export default "dist/images/components-icon-controls-plain.9b70a90.png";